var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
          'volume-button': true,
          'on': !_vm.isMute
        },attrs:{"type":"button"},on:{"click":_vm.toggleMute}},[_c('span',{staticClass:"a11y-hidden"},[_vm._v("볼륨 켜기")])])
}
var staticRenderFns = []

export { render, staticRenderFns }